import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ssoCorporateGroupId = '', ...params }) => {
  return await dponetAPI.get(`/sso_corporate_groups/${ssoCorporateGroupId}`, {
    params,
  })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post(`/sso_corporate_groups`, data)
}

const createForm = async ({ ...data }) => {
  return await dponetAPI.postForm(`/sso_corporate_groups`, data)
}

const update = async ({ ssoCorporateGroupId = '', ...ssoCorporateGroup }) => {
  return await dponetAPI.put(
    `/sso_corporate_groups/${ssoCorporateGroupId}`,
    ssoCorporateGroup,
  )
}

const updateForm = async ({
  ssoCorporateGroupId = '',
  ...ssoCorporateGroup
}) => {
  return await dponetAPI.putForm(
    `/sso_corporate_groups/${ssoCorporateGroupId}`,
    ssoCorporateGroup,
  )
}

const destroy = async ({ ssoCorporateGroupId = '' }) => {
  return await dponetAPI.delete(`/sso_corporate_groups/${ssoCorporateGroupId}`)
}

const verifyZitadelConnection = async ({ ssoCorporateGroupId = '' }) => {
  return await dponetAPI.get(
    `/sso_corporate_groups/${ssoCorporateGroupId}/verify_zitadel_connection`,
  )
}

const forceZitadelUpdate = async ({ ssoCorporateGroupId = '' }) => {
  return await dponetAPI.put(
    `/sso_corporate_groups/${ssoCorporateGroupId}/force_zitadel_update`,
  )
}

const downloadMetadata = async ({ ssoCorporateGroupId = '' }) => {
  return await dponetAPI.get(
    `/sso_corporate_groups/${ssoCorporateGroupId}/download_metadata`,
    { responseType: 'text' },
  )
}

const ssoCorporateGroups = {
  create,
  createForm,
  destroy,
  downloadMetadata,
  get,
  update,
  updateForm,
  verifyZitadelConnection,
  forceZitadelUpdate,
}

export default ssoCorporateGroups
